import { Loader } from "@mantine/core";

interface NumberLoaderProps {
  number?: number;
  size?: number;
}
export default function NumberLoader({ number, size = 10 }: NumberLoaderProps) {
  if (number === undefined) {
    return (
      <>
        <Loader size={size} />
      </>
    );
  }
  return <>{number}</>;
}
